import {gql} from '@apollo/client';
import {ComplaintAttachmentInput} from './types';

export const ASSIGN_COMPLAINT_TASK = gql`
    mutation AssignComplaintTask($taskId: Long!, $assigneeId: Long!, $reason: String) {
        assignComplaintTask(taskId: $taskId, assigneeId: $assigneeId, reason: $reason)
    }
`;

export const START_COMPLAINT_TASK = gql`
    mutation StartComplaintTask($taskId: Long!) {
        startComplaintTask(taskId: $taskId)
    }
`;

export const RESOLVE_COMPLAINT_TASK = gql`
    mutation ResolveComplaintTask($input: ResolveComplaintTaskInput!) {
        resolveComplaintTask(input: $input)
    }
`;

export interface ResolveComplaintTaskVariables {
  input: {taskId: number; content: string; attachments: ComplaintAttachmentInput[]};
}

export const PRESIGN_COMPLAINT_ATTACHMENT = gql`
    mutation PresignComplaintAttachment($fileName: String!, $contentType: String!, $size: Long) {
        presignComplaintAttachment(fileName: $fileName, contentType: $contentType, size: $size) {
            uploadUrl
            fileKey
            expiresAt
        }
    }
`;

export interface PresignComplaintAttachmentResponse {
  presignComplaintAttachment: {uploadUrl: string; fileKey: string; expiresAt: number};
}
